module.exports = __webpack_public_path__ + "static/media/ic_sip_mandate_attention.1eff3b0a.svg";